import { render, staticRenderFns } from "./AccountSettingDashboard.vue?vue&type=template&id=108ba2bd&scoped=true&"
import script from "./AccountSettingDashboard.vue?vue&type=script&lang=js&"
export * from "./AccountSettingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingDashboard.vue?vue&type=style&index=0&id=108ba2bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108ba2bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VForm,VIcon,VImg,VRow,VTextField})
